import { createSelector, createSlice } from '@reduxjs/toolkit';
import { FORM_TYPES } from '../../types/paramsConfig.js';
export const initialNavigationState = {
    navigationContext: 'none',
    activeForm: FORM_TYPES.LOGIN,
};
const navigationSlice = createSlice({
    name: 'navigationSlice',
    initialState: initialNavigationState,
    reducers: {
        setNavigationContext: (state, actions) => {
            state.navigationContext = actions.payload;
        },
        setActiveForm: (state, actions) => {
            state.activeForm = actions.payload;
        },
        navigateTo: (state, actions) => {
            // used for listener middlewares
            state.activeForm = actions.payload;
        },
    },
});
const navigationSelector = (state) => state.core.navigation;
export const selectNavigationContext = createSelector(navigationSelector, ({ navigationContext }) => navigationContext);
export const selectActiveForm = createSelector(navigationSelector, ({ activeForm }) => activeForm);
export const navigationActions = navigationSlice.actions;
export const { navigateTo } = navigationSlice.actions;
export default navigationSlice.reducer;
//# sourceMappingURL=navigationSlice.js.map